import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import Txt from "../../shared/textInput";
import { Checkbox, Dropdown, Form } from "semantic-ui-react";
import {
  updateAdvancedAppointmentStepData,
  updateEndDateDatePickerVisibility,
  updateRecurringOnDateDatePickerAppointment,
  getBookingsForResourceWithinDatesForClashSection,
  getBookingsForResourceWithinDatesForSpecificRecurringSection
} from "../../../actions/appointmentAdvancedStep";
import { updateAppointmentStepData } from "../../../actions/appointmentStep";
import { ValidMe, forceValidation } from "../../shared/validMeReact";
import DatePicker from "react-datepicker";
import moment from "moment";
import {
  noOptionSelectedFromRepeatListItem,
  dayValues
} from "../../../state/initialState";
import objectAssign from "object-assign";
import {
  roundUpDurationInFiveMinutesInterval,
  parseTimeIntervalIntoMinutesAndHours,
  dateRangeOneDay,
  calculateTotalAppointmentDuration,
  formatRepeatOnMonthlyUiDate,
  getFinalListOfServicesWithAccessAndNoAccess,
  convertDurationApi2ScreenFormat,
  addMultipleAppointmentDurations,
  getAmPmTime,
  get24sTime,
  apiLocalTimeToMoment,
  getParents,
  convertDateTimeFromApi,
  toApiDateTime,
  convertApiUtcToLocalMoment,
  canUserUseThisTimeDueToDoubleBookingDisabled,
  checkIfNewTimeWillCauseDoubleBooking,
  getRecurringOnTimeItem
} from "../../../utils/helpers";
import { removeGlobalErrorMessageIfMatchesThisString } from "../../../actions/globalError";
import ReactArrowHandler from "../../shared/reactArrowHandler";
import { paymentStatusEnum } from "../../../state/initialState";
import {
  getPurchasedOffer,
  removeOfferFromForm
} from "../../../actions/booking";
import { clone } from "../../../reducers/helper";

@connect(mapStateToProps)
export default class CenterPanelAppointmentAdvanced extends Component {
  constructor(props) {
    super(props);

    this.state = {
      goingBackInClashes: false,
      hover: false,
      handleClickOutsideClasTimeList: e => {
        if (
          !(e.target.className.indexOf("clash-time-dropdown") > -1) &&
          getParents(e.target, ".clash-time-dropdown").length == 0 &&
          !this.props.savingBooking
        ) {
          //this means the click did not happen inside the dropdown
          this.props.advancedAppointmentStepData.futureAppointmentClashesResolved.forEach(
            (o, indexOfClash) => {
              this.updateOpenClashTimeDropdownVisibility(false, indexOfClash);
            }
          );
        }
      }
    };
  }

  componentDidMount = () => {
    document.body.addEventListener(
      "click",
      this.state.handleClickOutsideClasTimeList
    );
  };

  componentWillUnmount = () => {
    document.body.removeEventListener(
      "click",
      this.state.handleClickOutsideClasTimeList
    );
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.advancedAppointmentStepData.futureAppointmentClashes.length >
        0 &&
      this.props.advancedAppointmentStepData.futureAppointmentClashes.length ==
        0
    ) {
      this.getDatesAvailableForCurrentStaffOnSelectedDateForClashSection(
        nextProps.advancedAppointmentStepData.futureAppointmentClashes[0]
          .startDateAndTime,
        this.props.appointmentStepData.multiServiceList[0].selectedStaff.id,
        this.props.currentBookingId,
        0
      );
    }

    if (
      nextProps.advancedAppointmentStepData.selectedRepeatOption.id == "D" &&
      nextProps.advancedAppointmentStepData.unavailableSpecificRecurringTimeList
        .length == 0 &&
      !nextProps.loadingAvailabilityDatesForSpecificRecurringSection &&
      !nextProps.loadedAvailabilitiesForSpecificRecurringAtLeastOnce
    ) {
      this.getDatesAvailableForCurrentStaffOnSelectedDateForSpecificRecurringSection(
        nextProps.advancedAppointmentStepData.selectedRecurringOnDate
      );
    }
  }

  updateOpenClashTimeDropdownVisibility(open, indexOfClash) {
    let {
      futureAppointmentClashes,
      futureAppointmentClashesResolved
    } = this.props.advancedAppointmentStepData;
    let dataToMerge = {
      openClashTimeDropdown: open
    };
    let fixedClash = objectAssign(
      {},
      futureAppointmentClashesResolved[indexOfClash] ||
        futureAppointmentClashes[indexOfClash],
      dataToMerge
    );
    futureAppointmentClashesResolved[indexOfClash] = fixedClash;
    this.updateThisStep({
      futureAppointmentClashesResolved: futureAppointmentClashesResolved
    });
  }

  dispatchUpdateAdvancedAppointmentStepData = advancedAppointmentStepData => {
    this.props.dispatch(
      updateAdvancedAppointmentStepData(advancedAppointmentStepData)
    );
  };

  updateThisStep = (data, multiItemIndexAdvanced) => {
    let { multiServiceAdvancedList } = this.props.advancedAppointmentStepData;
    let newData = "";
    newData = clone(this.props.advancedAppointmentStepData);
    if (multiItemIndexAdvanced != undefined) {
      newData.multiServiceAdvancedList[multiItemIndexAdvanced] = objectAssign(
        {},
        multiServiceAdvancedList[multiItemIndexAdvanced],
        data
      );
    } else {
      newData = objectAssign({}, this.props.advancedAppointmentStepData, data);
    }

    this.dispatchUpdateAdvancedAppointmentStepData(newData);
  };

  dispatchUpdateAppointmentStepData = appointmentStepData => {
    this.props.dispatch(updateAppointmentStepData(appointmentStepData));
  };

  updateAppointmentStep = (data, multiItemIndex) => {
    let { multiServiceList } = this.props.appointmentStepData;
    let newData = "";
    newData = clone(this.props.appointmentStepData);
    if (multiItemIndex != undefined) {
      newData.multiServiceList[multiItemIndex] = objectAssign(
        {},
        multiServiceList[multiItemIndex],
        data
      );
    } else {
      newData = objectAssign({}, this.props.appointmentStepData, data);
    }
    this.dispatchUpdateAppointmentStepData(newData);
  };

  handleRecurringEndOfPeriodRadioButtons = selectedRecurringEndOfPeriodRadioOption => {
    if (selectedRecurringEndOfPeriodRadioOption == "numberOfTimes") {
      this.updateThisStep({
        selectedRecurringEndOfPeriodRadioOption: selectedRecurringEndOfPeriodRadioOption,
        selectedTimeNumberOption: this.getDefaultTimeRecurring()
      });
    } else {
      this.updateThisStep({
        selectedRecurringEndOfPeriodRadioOption: selectedRecurringEndOfPeriodRadioOption
      });
    }
  };

  dispatchUpdateRecurringOnDateDatePickerAppointment = open => {
    this.props.dispatch(updateRecurringOnDateDatePickerAppointment(open));
  };

  getRecurringEndOfPeriodRadioButtons = () => {
    let {
      selectedRecurringEndOfPeriodRadioOption,
      selectedRepeatOption
    } = this.props.advancedAppointmentStepData;
    let {
      UntilDateOption,
      NumberOfTimesOption
    } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;

    if (
      selectedRepeatOption.id != "W" &&
      selectedRepeatOption.id != "M" &&
      selectedRepeatOption.id != "D"
    )
      return "";

    let untilDateKey = "untilDate";
    let numberOfTimesKey = "numberOfTimes";
    return (
      <Form className="end-of-period-radio-buttons">
        <Form.Field>
          <Checkbox
            radio
            label={UntilDateOption}
            name="endOfPeriodRadioGroup"
            value={untilDateKey}
            checked={selectedRecurringEndOfPeriodRadioOption === untilDateKey}
            onChange={this.handleRecurringEndOfPeriodRadioButtons.bind(
              this,
              untilDateKey
            )}
          />
        </Form.Field>
        <Form.Field>
          <Checkbox
            radio
            label={NumberOfTimesOption}
            name="endOfPeriodRadioGroup"
            value={numberOfTimesKey}
            checked={
              selectedRecurringEndOfPeriodRadioOption === numberOfTimesKey
            }
            onChange={this.handleRecurringEndOfPeriodRadioButtons.bind(
              this,
              numberOfTimesKey
            )}
          />
        </Form.Field>
      </Form>
    );
  };

  getAppointmentDateTimeSummary = multiServiceItem => {
    return (
      <div className="selected-date-time bookingDetails">
        <span className="bookingDetails_time">
          {multiServiceItem.selectedTime.value + " "}
        </span>
        <span className="bookingDetails_time">
          {moment(
            multiServiceItem.selectedDate._d || multiServiceItem.selectedDate
          ).format("MMMM Do, YYYY")}
        </span>
      </div>
    );
  };

  getSplitAppointmentTimeSummary = (
    multiServiceItemAdvanced,
    multiItemIndex
  ) => {
    let {
      appointmentDuration
    } = this.props.appointmentStepData.multiServiceList[multiItemIndex];
    let {
      splitAppointmentFreeTime,
      splitAppointmentFinishTime,
      splitAppointmentBufferTime
    } = multiServiceItemAdvanced;

    let totalMinutes =
      moment.duration(appointmentDuration)._milliseconds / 1000 / 60 +
      moment.duration(splitAppointmentFreeTime)._milliseconds / 1000 / 60 +
      moment.duration(splitAppointmentFinishTime)._milliseconds / 1000 / 60;

    let minutes = totalMinutes % 60,
      hours = Math.floor(totalMinutes / 60),
      timePrint = "";

    if (minutes > 60) {
      timePrint = `${hours}h ${minutes}min`;
    } else if (hours == 0) {
      timePrint = `${minutes}min`;
    } else {
      if (minutes == 0) {
        timePrint = `${hours}h`;
      } else {
        timePrint = `${hours}h ${minutes}min`;
      }
    }
    if (timePrint == "0min") {
      timePrint = "";
    }
    return timePrint;
  };

  getRepeatList() {
    let {
      Daily,
      Weekly,
      Monthly,
      Specific
    } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;
    return [
      { name: Daily, id: "D" },
      { name: Weekly, id: "W" },
      { name: Monthly, id: "M" },
      { name: Specific, id: "S" }
    ];
  }

  getRecurringRepeatDropdown = () => {
    let { selectedRepeatOption } = this.props.advancedAppointmentStepData;
    let { RepeatTitle } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;

    let repeatList = this.getRepeatList();

    let handleSelectRepeatOption = selectedRepeatOption => {
      this.updateThisStep({ selectedRepeatOption: selectedRepeatOption });
    };

    if (!selectedRepeatOption.name && selectedRepeatOption.id) {
      handleSelectRepeatOption(
        repeatList.find(x => x.id == selectedRepeatOption.id)
      );
    }

    return (
      <ReactArrowHandler iterateOver={".recurring-repeat-item"}>
        <Txt
          type="dropdown"
          className="recurring-repeat selection"
          title={RepeatTitle}
          tabIndex="0"
          placeholder={RepeatTitle}
          text={selectedRepeatOption.name || RepeatTitle}
        >
          <Dropdown.Menu>
            {repeatList.map(repeatOption => {
              return (
                <Dropdown.Item
                  key={repeatOption.id}
                  className={`${
                    repeatOption.id == selectedRepeatOption.id ? " hovered" : ""
                  } recurring-repeat-item`}
                  selected={repeatOption.id == selectedRepeatOption.id}
                  onClick={handleSelectRepeatOption.bind(this, repeatOption)}
                >
                  {repeatOption.name}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Txt>
      </ReactArrowHandler>
    );
  };
  handleSelectEveryMonthOption = selectedEveryMonthOption => {
    this.updateThisStep({ selectedEveryMonthOption: selectedEveryMonthOption });
  };

  getRecurringEveryMonthDropdown = () => {
    let {
      selectedEveryMonthOption,
      selectedRepeatOption
    } = this.props.advancedAppointmentStepData;
    let {
      Month,
      Months,
      EveryTitle
    } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;

    if (selectedRepeatOption.id != "M")
      //avoid rendering if we shouldnt
      return "";

    let getDefaultMonth = () => {
      return {
        id: "1monthrecurring",
        name: Month.replace("##number##", 1),
        value: 1
      };
    };

    let monthsDisplayed = [1, 2, 3, 4, 5, 6];

    let recurringEveryMonthList = monthsDisplayed.map(o => {
      let monthToReturn = {};
      if (o == 1)
        monthToReturn = {
          id: `${o}monthrecurring`,
          name: Month.replace("##number##", o),
          value: o
        };
      else {
        monthToReturn = {
          id: `${o}monthrecurring`,
          name: Months.replace("##number##", o),
          value: o
        };
      }
      return monthToReturn;
    });

    let getMonthItem = monthOption => {
      if (monthOption.value)
        monthOption = recurringEveryMonthList.find(
          x => x.value == monthOption.value
        );

      return monthOption.name || getDefaultMonth().name;
    };

    return (
      <div>
        <ReactArrowHandler iterateOver={".recurring-every-month-item"}>
          <Txt
            type="dropdown"
            className="recurring-every-month selection"
            placeholder={getDefaultMonth().name}
            title={EveryTitle}
            tabIndex="0"
            text={getMonthItem(selectedEveryMonthOption)}
          >
            <Dropdown.Menu>
              {recurringEveryMonthList.map(everyMonthOption => {
                return (
                  <Dropdown.Item
                    key={everyMonthOption.id}
                    className={`${
                      everyMonthOption.id == selectedEveryMonthOption.id
                        ? " hovered"
                        : ""
                    } recurring-every-month-item`}
                    selected={
                      everyMonthOption.id == selectedEveryMonthOption.id
                    }
                    onClick={this.handleSelectEveryMonthOption.bind(
                      this,
                      everyMonthOption
                    )}
                  >
                    {everyMonthOption.name}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Txt>
        </ReactArrowHandler>
      </div>
    );
  };

  handleSelectEveryWeekOption = selectedEveryWeekOption => {
    this.updateThisStep({ selectedEveryWeekOption: selectedEveryWeekOption });
  };

  getRecurringEveryWeekDropdown = () => {
    let {
      selectedEveryWeekOption,
      selectedRepeatOption
    } = this.props.advancedAppointmentStepData;
    let {
      Week,
      Weeks,
      EveryTitle
    } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;

    let getDefaultWeek = () => {
      return {
        id: "1weekrecurring",
        name: Week.replace("##number##", 1),
        value: 1
      };
    };

    if (selectedRepeatOption.id != "W")
      //avoid rendering if we shouldnt
      return "";

    let weeksDisplayed = [1, 2, 3, 4, 5, 6];

    let recurringEveryWeekList = weeksDisplayed.map(o => {
      let weekToReturn = {};
      if (o == 1)
        weekToReturn = {
          id: `${o}weekrecurring`,
          name: Week.replace("##number##", o),
          value: o
        };
      else {
        weekToReturn = {
          id: `${o}weekrecurring`,
          name: Weeks.replace("##number##", o),
          value: o
        };
      }
      return weekToReturn;
    });

    let getWeekItem = weekOption => {
      if (weekOption.value)
        weekOption = recurringEveryWeekList.find(
          x => x.value == weekOption.value
        );

      return weekOption.name || getDefaultWeek().name;
    };

    return (
      <div>
        <ReactArrowHandler iterateOver={".recurring-every-week-item"}>
          <Txt
            type="dropdown"
            tabIndex="0"
            className="recurring-every-week selection"
            placeholder={getDefaultWeek().name}
            title={EveryTitle}
            text={getWeekItem(selectedEveryWeekOption)}
          >
            <Dropdown.Menu>
              {recurringEveryWeekList.map(everyWeekOption => {
                return (
                  <Dropdown.Item
                    key={everyWeekOption.id}
                    className={`${
                      everyWeekOption.id == selectedEveryWeekOption.id
                        ? " hovered"
                        : ""
                    } recurring-every-week-item`}
                    selected={everyWeekOption.id == selectedEveryWeekOption.id}
                    onClick={this.handleSelectEveryWeekOption.bind(
                      this,
                      everyWeekOption
                    )}
                  >
                    {everyWeekOption.name}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Txt>
        </ReactArrowHandler>
      </div>
    );
  };

  handleSelectEveryDayOption = selectedEveryDayOption => {
    this.updateThisStep({ selectedEveryDayOption: selectedEveryDayOption });
  };

  getRecurringEveryDayDropdown = () => {
    let {
      selectedEveryDayOption,
      selectedRepeatOption
    } = this.props.advancedAppointmentStepData;
    let {
      Day,
      Days,
      EveryTitle
    } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;

    if (selectedRepeatOption.id != "D")
      //avoid rendering if we shouldnt
      return "";

    let getDefaultDay = () => {
      return {
        id: "1dayrecurring",
        name: Day.replace("##number##", 1),
        value: 1
      };
    };

    let daysDisplayed = [1, 2, 3, 4, 5, 6];

    let recurringEveryList = daysDisplayed.map(o => {
      let dayToReturn = {};
      if (o == 1)
        dayToReturn = {
          id: `${o}dayrecurring`,
          name: Day.replace("##number##", o),
          value: o
        };
      else {
        dayToReturn = {
          id: `${o}dayrecurring`,
          name: Days.replace("##number##", o),
          value: o
        };
      }
      return dayToReturn;
    });

    let getDayItem = dayOption => {
      if (dayOption.value)
        dayOption = recurringEveryList.find(x => x.value == dayOption.value);

      return dayOption.name || getDefaultDay().name;
    };

    return (
      <div>
        <ReactArrowHandler iterateOver={".recurring-every-day-item"}>
          <Txt
            type="dropdown"
            tabIndex="0"
            className="recurring-every-day selection"
            placeholder={getDefaultDay().name}
            title={EveryTitle}
            text={getDayItem(selectedEveryDayOption)}
          >
            <Dropdown.Menu>
              {recurringEveryList.map(everyDayOption => {
                return (
                  <Dropdown.Item
                    key={everyDayOption.id}
                    className={`${
                      everyDayOption.id == selectedEveryDayOption.id
                        ? " hovered"
                        : ""
                    } recurring-every-day-item`}
                    selected={everyDayOption.id == selectedEveryDayOption.id}
                    onClick={this.handleSelectEveryDayOption.bind(
                      this,
                      everyDayOption
                    )}
                  >
                    {everyDayOption.name}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Txt>{" "}
        </ReactArrowHandler>
      </div>
    );
  };

  dispatchUpdateEndDateDatePickerVisibility = open => {
    this.props.dispatch(updateEndDateDatePickerVisibility(open));
  };

  getRecurringEndDateDatePicker = () => {
    let {
      selectedEndDate,
      selectedRepeatOption,
      selectedRecurringEndOfPeriodRadioOption
    } = this.props.advancedAppointmentStepData;
    let { openEndDatePickerAppointment } = this.props;
    if (
      (selectedRepeatOption.id != "D" &&
        selectedRepeatOption.id != "W" &&
        selectedRepeatOption.id != "M") ||
      selectedRecurringEndOfPeriodRadioOption != "untilDate"
    ) {
      //avoid rendering if we shouldnt
      return "";
    }

    let selectEndDate = endDate => {
      this.updateThisStep({
        selectedEndDate:
          moment(endDate).format("YYYY") +
          "-" +
          moment(endDate).format("MM") +
          "-" +
          moment(endDate).format("DD") +
          "T" +
          moment(endDate).format("HH:mm")
      });
    };
    let onBlurDynamicEndDate = ev => {
      let endDate = ev.target.value;
      if (!moment(endDate).isValid()) {
        endDate = moment();
      }
      this.updateThisStep({
        selectedEndDate:
          moment(endDate).format("YYYY") +
          "-" +
          moment(endDate).format("MM") +
          "-" +
          moment(endDate).format("DD") +
          "T" +
          moment(endDate).format("HH:mm")
      });
    };
    let handleEndDateFocus = () => {
      let open = true;
      this.dispatchUpdateEndDateDatePickerVisibility(open);
    };
    let handleEndDateBlur = () => {
      let open = false;
      this.dispatchUpdateEndDateDatePickerVisibility(open);
    };

    return (
      <div className="field">
        <h5>
          {window.APP.LANGUAGE.Pages.AppointmentAdvanced.EndDateDropdownTitle}
        </h5>
        <ValidMe
          customvalidation={() => {
            return moment(selectedEndDate).isValid();
          }}
          defaulttext={""}
          validmemessage={window.APP.LANGUAGE.Errors.EndDateRequired}
          validmefor="dropdown"
          group="secondStepAdvancedAppointment"
        >
          <DatePicker
            endDateFormat="MMM DD, YYYY"
            readOnly
            selected={moment(selectedEndDate)}
            className={`booking-end-date`}
            calendarClassName="booking-end-date-picker"
            onChange={selectEndDate.bind(this)}
            onBlur={onBlurDynamicEndDate.bind(this)}
            disabledKeyboardNavigation
            popoverAttachment="bottom left"
            popoverTargetAttachment="top left"
          />
        </ValidMe>
      </div>
    );
  };

  getRecurringOnDatePicker = () => {
    let {
      selectedRecurringOnDate,
      selectedRepeatOption
    } = this.props.advancedAppointmentStepData;
    let { openRecurringOnDatePickerAppointment } = this.props;

    if (selectedRepeatOption.id != "S") {
      //avoid rendering if we shouldnt
      return "";
    }

    let selectRecurringOnDate = recurringOnDate => {
      let formattedSelectedDate =
        moment(recurringOnDate).format("YYYY") +
        "-" +
        moment(recurringOnDate).format("MM") +
        "-" +
        moment(recurringOnDate).format("DD") +
        "T" +
        moment(recurringOnDate).format("HH:mm");
      let dataToMerge = {
        selectedRecurringOnDate: formattedSelectedDate
      };
      this.updateThisStep(dataToMerge);
      this.getDatesAvailableForCurrentStaffOnSelectedDateForSpecificRecurringSection(
        formattedSelectedDate
      );
    };
    let onBlurDynamicRecurringOnDate = ev => {
      let recurringOnDate = ev.target.value;
      if (!moment(recurringOnDate).isValid()) {
        recurringOnDate = moment();
      }
      this.updateThisStep({
        selectedRecurringOnDate:
          moment(recurringOnDate).format("YYYY") +
          "-" +
          moment(recurringOnDate).format("MM") +
          "-" +
          moment(recurringOnDate).format("DD") +
          "T" +
          moment(recurringOnDate).format("HH:mm")
      });
    };
    let handleRecurringOnDateFocus = () => {
      let open = true;
      this.dispatchUpdateRecurringOnDateDatePickerAppointment(open);
    };
    let handleRecurringOnDateBlur = () => {
      let open = false;
      this.dispatchUpdateRecurringOnDateDatePickerAppointment(open);
    };

    return (
      <div className="field">
        <h5>
          {
            window.APP.LANGUAGE.Pages.AppointmentAdvanced
              .RecurringOnDateDropdownTitle
          }
        </h5>
        <ValidMe
          customvalidation={() => {
            return moment(selectedRecurringOnDate).isValid();
          }}
          defaulttext={""}
          validmemessage={window.APP.LANGUAGE.Errors.RecurringOnDateRequired}
          validmefor="dropdown"
          group="secondStepAdvancedAppointment"
        >
          <DatePicker
            recurringOnDateFormat="MMM DD, YYYY"
            readOnly
            selected={moment(selectedRecurringOnDate)}
            className={`booking_recurringOnDate`}
            onChange={selectRecurringOnDate.bind(this)}
            onBlur={onBlurDynamicRecurringOnDate.bind(this)}
            disabledKeyboardNavigation
            popoverAttachment="bottom left"
            popoverTargetAttachment="top left"
          />
        </ValidMe>
      </div>
    );
  };

  selectRecurringOnTime = recurringOnTime => {
    let {
      selectedRecurringOnDate,
      recurringOnTimeSelectedList,
      selectedRecurringOnTime,
      timeListForOnTimeRecurring,
      unavailableSpecificRecurringTimeList
    } = this.props.advancedAppointmentStepData;
    let {
      appointmentDuration,
      splitAppointmentFreeTime,
      splitAppointmentFinishTime,
      splitAppointmentBufferTime
    } = this.props.appointmentStepData.multiServiceList[0];
    let { doubleBookingEnabled } = this.props.appointmentStepData;

    let recurringOnTimeItem = getRecurringOnTimeItem(
      selectedRecurringOnDate,
      recurringOnTime
    );

    let totalAppointmentDuration = calculateTotalAppointmentDuration(
      appointmentDuration,
      splitAppointmentFreeTime,
      splitAppointmentFinishTime,
      splitAppointmentBufferTime
    );
    totalAppointmentDuration = totalAppointmentDuration.split(":");

    let totalMinutes =
      parseInt(totalAppointmentDuration[0]) * 60 +
      parseInt(totalAppointmentDuration[1]);

    if (recurringOnTimeSelectedList.indexOf(recurringOnTimeItem) > -1) {
      return; //do not add duplicated times
    }
    recurringOnTimeSelectedList.push(recurringOnTimeItem);

    let updateTime = true;
    if (
      !canUserUseThisTimeDueToDoubleBookingDisabled(
        selectedRecurringOnDate,
        recurringOnTime,
        selectedRecurringOnTime || recurringOnTime,
        totalMinutes,
        timeListForOnTimeRecurring,
        unavailableSpecificRecurringTimeList,
        this.props.dispatch,
        doubleBookingEnabled
      )
    ) {
      updateTime = false;
    }

    if (updateTime) {
      this.updateThisStep({
        recurringOnTimeSelectedList: recurringOnTimeSelectedList,
        selectedRecurringOnTime: recurringOnTime
      });
    }

    setTimeout(() => {
      let areThereErrors = forceValidation(
        null,
        null,
        "secondStepAdvancedAppointment"
      );
    }, 0); //to clear the validation of the selection box
  };

  getRecurringOnTimeDropdown = () => {
    let {
      selectedRecurringOnTime,
      selectedRepeatOption,
      timeListForOnTimeRecurring
    } = this.props.advancedAppointmentStepData;
    let { loadingAvailabilityDatesForSpecificRecurringSection } = this.props;
    let {
      RecurringOnTimeDropdownPlaceholder,
      RecurringOnTimeDropdownTitle
    } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;

    if (selectedRepeatOption.id != "S")
      //avoid rendering if we shouldnt
      return "";

    return (
      <ReactArrowHandler iterateOver={".specific-recurrence-item"}>
        <ValidMe
          defaulttext={RecurringOnTimeDropdownPlaceholder}
          validmemessage={window.APP.LANGUAGE.Errors.RecurringOnTimeRequired}
          validmefor="dropdown"
          group="secondStepAdvancedAppointment"
        >
          <Txt
            loading={loadingAvailabilityDatesForSpecificRecurringSection}
            type="dropdown"
            className="specific_recurrence dropdown selection"
            tabIndex="0"
            title={RecurringOnTimeDropdownTitle}
            placeholder={RecurringOnTimeDropdownPlaceholder}
            text={
              selectedRecurringOnTime.value ||
              RecurringOnTimeDropdownPlaceholder
            }
          >
            <Dropdown.Menu>
              {timeListForOnTimeRecurring.map(recurringOnTime => {
                return (
                  <Dropdown.Item
                    className={`${
                      selectedRecurringOnTime.value == recurringOnTime.value
                        ? " hovered"
                        : ""
                    } specific-recurrence-item`}
                    selected={
                      selectedRecurringOnTime.value == recurringOnTime.value
                    }
                    key={recurringOnTime.value}
                    disabled={recurringOnTime.disabled}
                    onClick={this.selectRecurringOnTime.bind(
                      this,
                      recurringOnTime
                    )}
                  >
                    {recurringOnTime.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Txt>
        </ValidMe>
      </ReactArrowHandler>
    );
  };

  handleSelectEveryTimeNumberOption = selectedTimeNumberOption => {
    this.updateThisStep({
      selectedTimeNumberOption: selectedTimeNumberOption
    });
  };

  getDefaultTimeRecurring = () => {
    let { Twice } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;
    return { id: "1timeNumberrecurring", name: Twice, value: 2 };
  };

  getRecurringMultipleTimesDropdown = () => {
    let {
      selectedTimeNumberOption,
      selectedRepeatOption,
      selectedRecurringEndOfPeriodRadioOption
    } = this.props.advancedAppointmentStepData;
    let {
      Twice,
      Times,
      EveryTitle
    } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;

    if (
      (selectedRepeatOption.id != "D" &&
        selectedRepeatOption.id != "W" &&
        selectedRepeatOption.id != "M") ||
      selectedRecurringEndOfPeriodRadioOption != "numberOfTimes"
    ) {
      //avoid rendering if we shouldnt
      return "";
    }

    let numberOfTimesDisplayed = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    let recurringNumberOfTimesList = [
      { id: "2timeNumberrecurring", name: Twice, value: 2 }
    ].concat(
      numberOfTimesDisplayed.map(o => {
        let timeNumberToReturn = {
          id: `${o}timeNumberrecurring`,
          name: Times.replace("##number##", o),
          value: o
        };
        return timeNumberToReturn;
      })
    );

    let getNumberOfTimesItem = timeNumberOption => {
      if (timeNumberOption.value)
        timeNumberOption = recurringNumberOfTimesList.find(
          x => x.value == timeNumberOption.value
        );

      return timeNumberOption.name || this.getDefaultTimeRecurring().name;
    };

    return (
      <ReactArrowHandler iterateOver={".recurring-multiple-times-item"}>
        <Txt
          type="dropdown"
          tabIndex="0"
          className="recurring-multiple-times selection"
          text={getNumberOfTimesItem(selectedTimeNumberOption)}
        >
          <Dropdown.Menu>
            {recurringNumberOfTimesList.map(timeNumberOption => {
              return (
                <Dropdown.Item
                  key={timeNumberOption.id}
                  className={`${
                    timeNumberOption.id == selectedTimeNumberOption.id
                      ? " hovered"
                      : ""
                  } recurring-multiple-times-item`}
                  selected={timeNumberOption.id == selectedTimeNumberOption.id}
                  onClick={this.handleSelectEveryTimeNumberOption.bind(
                    this,
                    timeNumberOption
                  )}
                >
                  {timeNumberOption.name}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Txt>
      </ReactArrowHandler>
    );
  };

  handleSelectRepeatOnMonthOption = selectedRepeatOnMonthOptionSelected => {
    this.updateThisStep({
      selectedRepeatOnMonthOptionSelected: selectedRepeatOnMonthOptionSelected
    });
  };

  getRepeatOnMonthCheckboxList = () => {
    let {
      selectedRepeatOnMonthOptionSelected,
      selectedRecurringEndOfPeriodRadioOption,
      selectedRepeatOption
    } = this.props.advancedAppointmentStepData;
    let { selectedDate } = this.props.appointmentStepData.multiServiceList[0];
    let { RepeatOnTitle } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;

    if (selectedRepeatOption.id != "M")
      //avoid rendering if we shouldnt
      return "";

    let firstOption = formatRepeatOnMonthlyUiDate(selectedDate);
    let secondOption = formatRepeatOnMonthlyUiDate(selectedDate);
    let firstOptionValue = "dayofweek";
    let secondOptionValue = "dayofmonth";
    return (
      <div className="monthly_recurrence">
        <h5>{RepeatOnTitle}</h5>
        <Form>
          <Form.Field>
            <Checkbox
              radio
              label={firstOption.dayOfWeekOfMonth}
              name="repeatOnMonthCheckboxGroup"
              value={firstOptionValue.dayOfWeekOfMonth}
              checked={selectedRepeatOnMonthOptionSelected == firstOptionValue}
              onChange={this.handleSelectRepeatOnMonthOption.bind(
                this,
                firstOptionValue
              )}
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              radio
              label={secondOption.dayOfMonth}
              name="repeatOnMonthCheckboxGroup"
              value={secondOptionValue.dayOfMonth}
              checked={selectedRepeatOnMonthOptionSelected == secondOptionValue}
              onChange={this.handleSelectRepeatOnMonthOption.bind(
                this,
                secondOptionValue
              )}
            />
          </Form.Field>
        </Form>
      </div>
    );
  };

  handleSelectRepeatOnOption = option => {
    let {
      selectedRepeatOnOptionsSelected
    } = this.props.advancedAppointmentStepData;

    let newOptionIndex = selectedRepeatOnOptionsSelected.indexOf(option);
    if (newOptionIndex > -1) {
      selectedRepeatOnOptionsSelected.splice(newOptionIndex, 1);
    } else {
      selectedRepeatOnOptionsSelected.push(option);
    }
    this.updateThisStep({
      selectedRepeatOnOptionsSelected: selectedRepeatOnOptionsSelected
    });
  };

  getRepeatOnWeekCheckboxList = () => {
    let {
      selectedRepeatOnOptionsSelected,
      selectedRecurringEndOfPeriodRadioOption,
      selectedRepeatOption,
      listOfNonEditableRepeatOnOptionsSelected
    } = this.props.advancedAppointmentStepData;
    let {
      RepeatOnTitle,
      Monday,
      Tuesday,
      Wednesday,
      Thursday,
      Friday,
      Saturday,
      Sunday
    } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;

    if (selectedRepeatOption.id != "W")
      //avoid rendering if we shouldnt
      return "";

    let isDisabled = day => {
      let foundDay = {};
      foundDay = !!listOfNonEditableRepeatOnOptionsSelected[
        selectedRepeatOnOptionsSelected.indexOf(day)
      ];
      return foundDay;
    };

    return (
      <div className="recurrence_checkboxes">
        <h5>{RepeatOnTitle}</h5>
        <Form>
          <Form.Field>
            <Checkbox
              label={Monday}
              disabled={isDisabled(dayValues.Mon)}
              name="repeatOnCheckboxGroup"
              value={dayValues.Mon}
              checked={
                selectedRepeatOnOptionsSelected.indexOf(dayValues.Mon) > -1
              }
              onChange={this.handleSelectRepeatOnOption.bind(
                this,
                dayValues.Mon
              )}
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              label={Tuesday}
              disabled={isDisabled(dayValues.Tue)}
              name="repeatOnCheckboxGroup"
              value={dayValues.Tue}
              checked={
                selectedRepeatOnOptionsSelected.indexOf(dayValues.Tue) > -1
              }
              onChange={this.handleSelectRepeatOnOption.bind(
                this,
                dayValues.Tue
              )}
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              label={Wednesday}
              name="repeatOnCheckboxGroup"
              value={dayValues.Wed}
              disabled={isDisabled(dayValues.Wed)}
              checked={
                selectedRepeatOnOptionsSelected.indexOf(dayValues.Wed) > -1
              }
              onChange={this.handleSelectRepeatOnOption.bind(
                this,
                dayValues.Wed
              )}
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              label={Thursday}
              disabled={isDisabled(dayValues.Thu)}
              name="repeatOnCheckboxGroup"
              value={dayValues.Thu}
              checked={
                selectedRepeatOnOptionsSelected.indexOf(dayValues.Thu) > -1
              }
              onChange={this.handleSelectRepeatOnOption.bind(
                this,
                dayValues.Thu
              )}
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              label={Friday}
              disabled={isDisabled(dayValues.Fri)}
              name="repeatOnCheckboxGroup"
              value={dayValues.Fri}
              checked={
                selectedRepeatOnOptionsSelected.indexOf(dayValues.Fri) > -1
              }
              onChange={this.handleSelectRepeatOnOption.bind(
                this,
                dayValues.Fri
              )}
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              label={Saturday}
              disabled={isDisabled(dayValues.Sat)}
              name="repeatOnCheckboxGroup"
              value={dayValues.Sat}
              checked={
                selectedRepeatOnOptionsSelected.indexOf(dayValues.Sat) > -1
              }
              onChange={this.handleSelectRepeatOnOption.bind(
                this,
                dayValues.Sat
              )}
            />
          </Form.Field>
          <Form.Field>
            <Checkbox
              label={Sunday}
              disabled={isDisabled(dayValues.Sun)}
              name="repeatOnCheckboxGroup"
              value={dayValues.Sun}
              checked={
                selectedRepeatOnOptionsSelected.indexOf(dayValues.Sun) > -1
              }
              onChange={this.handleSelectRepeatOnOption.bind(
                this,
                dayValues.Sun
              )}
            />
          </Form.Field>
        </Form>
      </div>
    );
  };

  handleRecurringToggle = (ev, state, asd) => {
    let {
      selectedRecurringEndOfPeriodRadioOption
    } = this.props.advancedAppointmentStepData;
    let {
      RecurrenceKeywordFoundInRecurringAppointmentErrors
    } = window.APP.LANGUAGE.Errors;
    let repeatList = this.getRepeatList();

    let recurringToggleOn = state.checked
      ? repeatList[0]
      : noOptionSelectedFromRepeatListItem;
    if (!state.checked) {
      //when this toggle is not on, hide all recurrence related errors
      this.props.dispatch(
        removeGlobalErrorMessageIfMatchesThisString(
          RecurrenceKeywordFoundInRecurringAppointmentErrors
        )
      );
    }

    this.updateThisStep({
      selectedRepeatOption: recurringToggleOn,
      recurringToggleOn: state.checked
    });
    //if the recurring option is switch off, we need to send noOptionSelectedFromRepeatListItem
  };

  handleRecurMouseIn = () => {
    this.setState({ hover: true });
  };

  handleRecurMouseOut = () => {
    this.setState({ hover: false });
  };

  removeItemFromOnTimeList = itemIndex => {
    let {
      recurringOnTimeSelectedList
    } = this.props.advancedAppointmentStepData;
    recurringOnTimeSelectedList.splice(itemIndex, 1);
    this.updateThisStep({
      recurringOnTimeSelectedList: recurringOnTimeSelectedList
    });
    setTimeout(() => {
      let areThereErrors = forceValidation(
        null,
        null,
        "secondStepAdvancedAppointment"
      );
    }, 2); //to check if there are no times selected when you delete an entry
  };

  getBoxOfRecurringOnTimeList = () => {
    let {
      recurringOnTimeSelectedList,
      selectedRepeatOption
    } = this.props.advancedAppointmentStepData;

    if (selectedRepeatOption.id != "S")
      //avoid rendering if we shouldnt
      return "";

    return (
      <ValidMe
        fieldclasses=" "
        condition={() => {
          return (
            this.props.advancedAppointmentStepData.recurringOnTimeSelectedList
              .length > 0
          );
        }}
        validmemessagecondition={
          window.APP.LANGUAGE.Errors.SpecificRecurringTimeSelectionRequired
        }
        validmefor="condition"
        group="secondStepAdvancedAppointment"
      >
        <div className="current_appointment_occurrence_wrapper">
          <div className="current_appointment_occurrence validation-box">
            {recurringOnTimeSelectedList.map((o, i) => {
              return (
                <div
                  key={`${o.split("^")[0].split("|")[0]}${
                    o.split("^")[0].split("|")[1]
                  }`}
                >
                  <span className="current_appointment_occurrence_date">
                    {o.split("^")[0].split("|")[0]}
                  </span>
                  <span className="current_appointment_occurrence_time">
                    {o.split("^")[0].split("|")[1]}
                  </span>
                  <div
                    className="del_icon"
                    onClick={this.removeItemFromOnTimeList.bind(this, i)}
                  ></div>
                </div>
              );
            })}
          </div>
        </div>
      </ValidMe>
    );
  };

  getServiceRow = (
    multiServiceItem,
    multiItemIndex,
    index,
    disabled = false
  ) => {
    let { selectedService } = multiServiceItem;
    let { currentBookingId, loadingBooking, bookingChannel } = this.props;
    let {
      selectedAppointmentStatus,
      paymentStatus
    } = this.props.appointmentStepData;
    let {
      multiServiceAdvancedList,
      offerId,
      bookingCameFromDbWithOffer
    } = this.props.advancedAppointmentStepData;
    let {
      Pages: { AppointmentAdvanced, Appointment },
      Errors
    } = window.APP.LANGUAGE;

    let multiServiceItemAdvanced = multiServiceAdvancedList[multiItemIndex];

    if (currentBookingId != multiServiceItem.bookingId) {
      // i am therefore a sibbling
      disabled = true;
      if (this.props[`loadingSibblingBooking_${multiServiceItem.bookingId}`]) {
        loadingBooking = true;
      } else {
        loadingBooking = false;
      }
    }

    if (!disabled) {
      disabled = selectedAppointmentStatus.id == 5;
    }

    let handleFinishAppointmentChange = (ev, reactEv, hardValue) => {
      let value = hardValue || ev.target.value.replace(/[^0-9.:]/g, "");
      this.updateThisStep(
        {
          splitAppointmentFinishTime: value
        },
        multiItemIndex
      );
    };

    let handleAppointmentBufferChange = (ev, reactEv, hardValue) => {
      let value = hardValue || ev.target.value.replace(/[^0-9.:]/g, "");
      this.updateThisStep(
        {
          splitAppointmentBufferTime: value
        },
        multiItemIndex
      );
    };

    let handleFreeTimeAppointmentChange = (ev, reactEv, hardValue) => {
      let value = hardValue || ev.target.value.replace(/[^0-9.:]/g, "");
      this.updateThisStep(
        {
          splitAppointmentFreeTime: value
        },
        multiItemIndex
      );
    };

    let handleStartTimeAppointmentChange = (ev, reactEv, hardValue) => {
      let value = hardValue || ev.target.value;
      value = value.replace(/[^0-9.:]/g, "");
      this.updateAppointmentStep(
        {
          appointmentDuration: value
        },
        multiItemIndex
      );
    };

    // if (!multiServiceItem.appointmentDuration && selectedService.duration){
    //   handleStartTimeAppointmentChange(null,null,convertDurationApi2ScreenFormat(selectedService.duration || ''));
    // }
    // if (!multiServiceItemAdvanced.splitAppointmentFreeTime && selectedService.availableduration){
    //   handleFreeTimeAppointmentChange(null,null,convertDurationApi2ScreenFormat(selectedService.availableduration || ''));
    // }
    // if (!multiServiceItemAdvanced.splitAppointmentFinishTime && selectedService.secondduration){
    //   handleFinishAppointmentChange(null,null,convertDurationApi2ScreenFormat(selectedService.secondduration || ''));
    // }
    // if (!multiServiceItemAdvanced.splitAppointmentBufferTime && selectedService.bufferpostduration){
    //   handleAppointmentBufferChange(null,null,convertDurationApi2ScreenFormat(selectedService.bufferpostduration || ''));
    // }
    let that = this;

    if (!multiServiceItemAdvanced) {
      return;
    }

    return (
      <div className="middle-section two fields split-buffer-container mrbnull ">
        <div className="ui field service-info pdbnull">
          {index == 0 ? (
            <h5 className="label-title">{AppointmentAdvanced.ServiceTitle}</h5>
          ) : (
            ""
          )}
          <div className=" servicelabel">
            {selectedService.id ? (
              <span>
                <span>{selectedService.name}</span>
              </span>
            ) : (
              AppointmentAdvanced.NoServiceSelectedPlaceholder
            )}
            {this.getAppointmentDateTimeSummary(multiServiceItem)}
          </div>
        </div>
        {/* <div className="ui pdbnull cost-section">
          {index == 0 ? <h5>{AppointmentAdvanced.ServicePriceTitle}</h5> : ''}
          <Txt type="input" tabIndex={`${disabled ? '-1' : '0'}`} disabled={disabledPrice} onChange={handleServicePriceChange}  placeholder={AppointmentAdvanced.ServicePricePlaceholder} value={window.APP.LANGUAGE.Currency + (selectedService.price || 0)}></Txt>
        </div> DES-786 moved to Appointment screen*/}

        <div className="ui fields split_buffer pdbnull">
          <div className="appointment">
            {index == 0 ? (
              <h5>{AppointmentAdvanced.SplitAppointmentTitle}</h5>
            ) : (
              ""
            )}
            <div className="ui three fields">
              <ValidMe
                fieldclasses=" "
                validmemessagecondition={Errors.StartTimeRequired}
                validmefor="condition"
                condition={() => {
                  if (
                    ((that.props.advancedAppointmentStepData
                      .multiServiceAdvancedList[multiItemIndex]
                      .splitAppointmentFinishTime &&
                      that.props.advancedAppointmentStepData
                        .multiServiceAdvancedList[multiItemIndex]
                        .splitAppointmentFinishTime.length > 0) ||
                      (that.props.advancedAppointmentStepData
                        .multiServiceAdvancedList[multiItemIndex]
                        .splitAppointmentFreeTime &&
                        !!that.props.advancedAppointmentStepData
                          .multiServiceAdvancedList[multiItemIndex]
                          .splitAppointmentFreeTime.length > 0)) &&
                    multiServiceItem.appointmentDuration.length == 0
                  ) {
                    return false;
                  } else {
                    return true;
                  }
                }}
                group="secondStepAdvancedAppointment"
              >
                <Txt
                  type="input"
                  tabIndex={`${disabled ? "-1" : "0"}`}
                  disabled={disabled}
                  className="split_input duration-time"
                  onChange={handleStartTimeAppointmentChange}
                  onBlur={() => {
                    this.updateAppointmentStep(
                      {
                        appointmentDuration: parseTimeIntervalIntoMinutesAndHours(
                          roundUpDurationInFiveMinutesInterval(
                            multiServiceItem.appointmentDuration
                          ).toString()
                        )
                      },
                      multiItemIndex
                    );
                  }}
                  placeholder={AppointmentAdvanced.SplitFirstPartPlaceholder}
                  value={multiServiceItem.appointmentDuration}
                ></Txt>
              </ValidMe>
              <ValidMe
                fieldclasses=" "
                condition={() => {
                  if (
                    !!that.props.advancedAppointmentStepData
                      .multiServiceAdvancedList[multiItemIndex]
                      .splitAppointmentFinishTime &&
                    !that.props.advancedAppointmentStepData
                      .multiServiceAdvancedList[multiItemIndex]
                      .splitAppointmentFreeTime
                  ) {
                    return false;
                  } else {
                    return true;
                  }
                }}
                validmemessagecondition={
                  Errors.FinishTimeIsRequiredWhenFreeSpecified
                }
                validmefor="condition"
                group="secondStepAdvancedAppointment"
              >
                <Txt
                  type="input"
                  tabIndex={`${disabled ? "-1" : "0"}`}
                  disabled={disabled}
                  onBlur={() => {
                    this.updateThisStep(
                      {
                        splitAppointmentFreeTime: parseTimeIntervalIntoMinutesAndHours(
                          roundUpDurationInFiveMinutesInterval(
                            multiServiceItemAdvanced.splitAppointmentFreeTime
                          ).toString()
                        )
                      },
                      multiItemIndex
                    );
                    setTimeout(() => {
                      let areThereErrors = forceValidation(
                        null,
                        null,
                        "secondStepAdvancedAppointment"
                      );
                    }, 0);
                  }}
                  className="split_input free-time"
                  onChange={handleFreeTimeAppointmentChange}
                  placeholder={AppointmentAdvanced.SplitSecondPartPlaceholder}
                  value={multiServiceItemAdvanced.splitAppointmentFreeTime}
                ></Txt>
              </ValidMe>
              <ValidMe
                fieldclasses=" "
                condition={() => {
                  if (
                    !!that.props.advancedAppointmentStepData
                      .multiServiceAdvancedList[multiItemIndex]
                      .splitAppointmentFreeTime &&
                    !that.props.advancedAppointmentStepData
                      .multiServiceAdvancedList[multiItemIndex]
                      .splitAppointmentFinishTime
                  ) {
                    return false;
                  } else {
                    return true;
                  }
                }}
                validmemessagecondition={
                  Errors.FreeTimeIsRequiredWhenFinishSpecified
                }
                validmefor="condition"
                group="secondStepAdvancedAppointment"
              >
                <Txt
                  type="input"
                  disabled={disabled}
                  tabIndex={`${disabled ? "-1" : "0"}`}
                  className="split_input finish-time"
                  onChange={handleFinishAppointmentChange}
                  onBlur={() => {
                    this.updateThisStep(
                      {
                        splitAppointmentFinishTime: parseTimeIntervalIntoMinutesAndHours(
                          roundUpDurationInFiveMinutesInterval(
                            multiServiceItemAdvanced.splitAppointmentFinishTime
                          ).toString()
                        )
                      },
                      multiItemIndex
                    );
                  }}
                  placeholder={AppointmentAdvanced.SplitThirdPartPlaceholder}
                  value={multiServiceItemAdvanced.splitAppointmentFinishTime}
                ></Txt>
              </ValidMe>
            </div>
          </div>
          <div className="appointment-time-summary">
            {index == 0 ? <h5>{AppointmentAdvanced.TotalTitle}</h5> : ""}
            <input
              type="text"
              className="form-control  booking_duration"
              readOnly
              tabIndex="-1"
              value={this.getSplitAppointmentTimeSummary(
                multiServiceItemAdvanced,
                multiItemIndex
              )}
            />
          </div>
          <div className={`plus-symbol ${index == 0 ? "first-row" : ""}`}>
            {" "}
            +{" "}
          </div>
          <div className="appointment-buffer-time">
            <Txt
              type="input"
              disabled={disabled}
              tabIndex={`${disabled ? "-1" : "0"}`}
              className="bufferLabel"
              title={index == 0 ? AppointmentAdvanced.BufferTitle : ""}
              onChange={handleAppointmentBufferChange}
              onBlur={() => {
                this.updateThisStep(
                  {
                    splitAppointmentBufferTime: parseTimeIntervalIntoMinutesAndHours(
                      roundUpDurationInFiveMinutesInterval(
                        multiServiceItemAdvanced.splitAppointmentBufferTime
                      ).toString()
                    )
                  },
                  multiItemIndex
                );
              }}
              placeholder={AppointmentAdvanced.BufferPlaceholder}
              value={multiServiceItemAdvanced.splitAppointmentBufferTime}
            ></Txt>
          </div>
        </div>
      </div>
    );
  };

  getBookingRowsWithoutAccess = () => {
    let { MultiServiceNoAccessMessage } = window.APP.LANGUAGE.Pages.Appointment;
    return (
      <div className="split-buffer-container no-access-row">
        <div className="no-access-service-container">
          {MultiServiceNoAccessMessage}
        </div>
        {/* <div className="no-access-cost-section">--</div> */}
        <div className="split_buffer">
          <div className="appointment no-access">
            <div className="no-access-split-container">--</div>
            <div className="no-access-split-container">&nbsp;</div>
            <div className="no-access-split-container">&nbsp;</div>
          </div>
          <div className="appointment-time-summary">
            <div className="no-access-total-container">--</div>
          </div>
          <div className="plus-symbol">&nbsp;</div>
          <div className="appointment-buffer-time">
            <div className="no-access-buffer-container">&nbsp;</div>
          </div>
        </div>
      </div>
    );
  };

  getDatesAvailableForCurrentStaffOnSelectedDateForClashSection = (
    newlySelectedDate,
    staffId,
    bookingId,
    indexOfClash
  ) => {
    let newlySelectedStaffId = staffId;
    if (newlySelectedStaffId && newlySelectedDate) {
      const rangedDate = dateRangeOneDay(newlySelectedDate);
      this.props.dispatch(
        getBookingsForResourceWithinDatesForClashSection(
          newlySelectedStaffId,
          rangedDate.apiStartDate,
          rangedDate.apiEndDate,
          bookingId,
          newlySelectedDate,
          indexOfClash
        )
      );
    }
    if (!newlySelectedDate) {
      logger.warn("time does not exist");
    }
  };

  getDatesAvailableForCurrentStaffOnSelectedDateForSpecificRecurringSection = newlySelectedDate => {
    let { selectedStaff } = this.props.appointmentStepData.multiServiceList[0];
    if (newlySelectedDate) {
      const rangedDate = dateRangeOneDay(newlySelectedDate);
      this.props.dispatch(
        getBookingsForResourceWithinDatesForSpecificRecurringSection(
          selectedStaff.id,
          rangedDate.apiStartDate,
          rangedDate.apiEndDate,
          newlySelectedDate
        )
      );
    }
    if (!newlySelectedDate) {
      logger.warn("time does not exist");
    }
  };

  getPurchagedOfferRedeemingInput = () => {
    let {
      Pages: { AppointmentAdvanced }
    } = window.APP.LANGUAGE;
    let {
      advancedAppointmentStepData: { offerId, bookingCameFromDbWithOffer },
      loadingPurchasedOffer,
      gotValidOffer,
      getting,
      currentBookingId
    } = this.props;
    let { selectedAppointmentStatus } = this.props.appointmentStepData;
    let elementToReturn = "";

    if (currentBookingId && !bookingCameFromDbWithOffer) {
      return;
    }

    let handleTyping = ev => {
      this.updateThisStep({
        offerId: ev.target.value
      });
    };
    let handleClick = () => {
      if (offerId && !loadingPurchasedOffer && !gotValidOffer) {
        this.props.dispatch(getPurchasedOffer(offerId));
      }
    };

    let handleBlur = () => {
      if (offerId && !loadingPurchasedOffer && !gotValidOffer) {
        this.props.dispatch(getPurchasedOffer(offerId));
      }
    };

    let handleEnter = e => {
      if (
        offerId &&
        !loadingPurchasedOffer &&
        (e.keyCode === 13 || e.keyCode === 9) &&
        !gotValidOffer
      ) {
        this.props.dispatch(getPurchasedOffer(offerId));
      }
    };
    let dispatchRemoveOffer = () => {
      this.props.dispatch(removeOfferFromForm());
      this.updateThisStep({
        offerId: ""
      });
    };

    let getActions = () => {
      let actionsToReturn = "";
      if (!loadingPurchasedOffer && !bookingCameFromDbWithOffer) {
        actionsToReturn = gotValidOffer ? (
          <i onClick={dispatchRemoveOffer} className="trash"></i>
        ) : offerId ? (
          <i onClick={handleClick} className="checkmark"></i>
        ) : (
          <i className="checkmark-inactive"></i>
        );
      }
      return actionsToReturn;
    };

    let disabled =
      gotValidOffer ||
      loadingPurchasedOffer ||
      selectedAppointmentStatus.id == 5;
    elementToReturn = (
      <div className="offer_container">
        <Txt
          type="input"
          loading={loadingPurchasedOffer}
          onKeyDown={handleEnter}
          onBlur={handleBlur}
          tabIndex={`${disabled ? "-1" : "0"}`}
          disabled={disabled}
          className={`purchased-offer-redeemer ${
            gotValidOffer ? "valid-offer-loaded" : ""
          }`}
          onChange={handleTyping}
          placeholder={AppointmentAdvanced.PurchagedOfferPlaceholder}
          value={offerId}
        ></Txt>
        {getActions()}
      </div>
    );

    return elementToReturn;
  };

  getClashRecurrenceSection = () => {
    let {
      appointmentStepData: { multiServiceList },
      currentBookingId,
      loadingBooking
    } = this.props;
    let {
      advancedAppointmentStepData: {
        selectedRepeatOption,
        futureAppointmentClashes,
        futureAppointmentClashesResolved,
        timeListForClashes,
        currentClashBeingResolved
      }
    } = this.props;

    let {
      Pages: { Appointment, AppointmentAdvanced },
      Errors,
      Errors: { DateRequired }
    } = window.APP.LANGUAGE;

    if (futureAppointmentClashes.length == 0) {
      return "";
    }

    let updateClashData = (dataToMerge, indexOfClash) => {
      let fixedClash = {};

      if (!futureAppointmentClashesResolved[indexOfClash]) {
        // if it doesnt exist, copy all data
        fixedClash = objectAssign(
          {},
          futureAppointmentClashes[indexOfClash],
          dataToMerge
        );
      } else {
        //if it exists , pick from the solved array of data
        fixedClash = objectAssign(
          {},
          futureAppointmentClashesResolved[indexOfClash],
          dataToMerge
        );
      }
      futureAppointmentClashesResolved[indexOfClash] = fixedClash;
      this.updateThisStep({
        futureAppointmentClashesResolved: futureAppointmentClashesResolved
      });
    };

    let getClashDateDropdownSelector = (
      clashItem,
      indexOfClash,
      multiServiceItem,
      multiItemIndex,
      disabled
    ) => {
      let { startDateAndTime, openDatePickerForClash } = clashItem;

      let selectDate = date => {
        let formattedSelectedDate =
          moment(date).format("YYYY") +
          "-" +
          moment(date).format("MM") +
          "-" +
          moment(date).format("DD") +
          "T" +
          moment(date).format("HH:mm");
        let dataToMerge = {
          startDateAndTime: formattedSelectedDate
        };
        updateClashData(dataToMerge, indexOfClash);
        this.getDatesAvailableForCurrentStaffOnSelectedDateForClashSection(
          formattedSelectedDate,
          multiServiceItem.selectedStaff.id,
          currentBookingId,
          indexOfClash
        );
      };

      let onBlurDynamicDate = ev => {
        let date = ev.target.value;
        if (!moment(date).isValid()) {
          date = moment();
        }
        let formattedSelectedDate =
          moment(date).format("YYYY") +
          "-" +
          moment(date).format("MM") +
          "-" +
          moment(date).format("DD") +
          "T" +
          moment(date).format("HH:mm");
        let dataToMerge = {
          startDateAndTime: formattedSelectedDate
        };
        updateClashData(dataToMerge, indexOfClash);
      };

      let handleDateFocus = () => {
        let open = true;
        let dataToMerge = {
          openDatePickerForClash: open
        };
        updateClashData(dataToMerge, indexOfClash);
      };

      let handleDateBlur = () => {
        let open = false;
        let dataToMerge = {
          openDatePickerForClash: open
        };
        updateClashData(dataToMerge, indexOfClash);
      };

      return (
        <div
          className={`field mrbnull ${disabled ? "disabled-insensitive" : ""}`}
        >
          <ValidMe
            customvalidation={() => {
              return moment(clashItem.startDateAndTime).isValid();
            }}
            defaulttext={""}
            validmemessage={DateRequired}
            validmefor="dropdown"
            group="firstStepAppointment"
          >
            <DatePicker
              dateFormat="MMM DD, YYYY"
              readOnly
              selected={moment(clashItem.startDateAndTime)}
              className={`booking_date ${disabled ? " border-right-null" : ""}`}
              onChange={selectDate.bind(this)}
              onBlur={onBlurDynamicDate.bind(this)}
              popoverAttachment="bottom left"
              popoverTargetAttachment="top left"
            />
          </ValidMe>
        </div>
      );
    };

    let getClashTimeDropdownSelector = (
      clashItem,
      indexOfClash,
      multiServiceItem,
      multiItemIndex,
      disabled = false
    ) => {
      let {
        selectedTime,
        temporarilySelectedTime,
        selectedDate,
        appointmentDuration,
        selectedService
      } = multiServiceItem;
      let {
        splitAppointmentFinishTime,
        splitAppointmentBufferTime,
        splitAppointmentFreeTime
      } = this.props.advancedAppointmentStepData.multiServiceAdvancedList[
        multiItemIndex
      ];
      let {
        selectedAppointmentStatus,
        unavailableTimeList,
        doubleBookingEnabled,
        timeList,
        timeSlotsContainingAppointments
      } = this.props.appointmentStepData;
      let {
        startDateAndTime,
        temporarilySelectedTimeForClash,
        startTime,
        openClashTimeDropdown,
        loadingClash
      } = clashItem;

      let {
        loadingTimesForCurrentResource,
        currentBookingId,
        loadingBooking
      } = this.props;

      let sortAmPmTime = (a, b) => {
        let valueA = a.stringValue;
        let valueB = b.stringValue;
        valueA = parseFloat(valueA, 10);
        valueB = parseFloat(valueB, 10);
        if (valueA > valueB) {
          return 1;
        } else if (valueA < valueB) {
          return -1;
        } else {
          return 0;
        }
      };

      let parseAndFormatEnteredTime = () => {
        let finalValue = temporarilySelectedTimeForClash;
        if (finalValue == "") return;

        finalValue = finalValue.toLowerCase();

        if (finalValue.includes("pm")) {
          let leftValue = finalValue.split(":")[0] || 0;
          leftValue = parseInt(leftValue, 10);
          if (leftValue < 12) leftValue += 12;
          if (leftValue) {
            finalValue =
              leftValue +
              ":" +
              (finalValue.split(":")[1] || "00").replace("pm", "");
          }
        }
        if (finalValue.includes("am")) {
          finalValue = finalValue.replace("am", ""); // ignore am
        }

        if (!finalValue.includes(":")) finalValue += ":00";
        let roundedUpDuration =
          roundUpDurationInFiveMinutesInterval(finalValue) + "";

        let parsedDuration = parseTimeIntervalIntoMinutesAndHours(
          roundedUpDuration
        );

        let pmAmDuration = getAmPmTime(parsedDuration);
        if (temporarilySelectedTime.toLowerCase().includes("am")) {
          // to fix times between 12 - 1 am
          pmAmDuration = pmAmDuration.replace("pm", "am");
        }
        let parsed24hsDuration = get24sTime(pmAmDuration);

        if (
          parsed24hsDuration.includes("24") &&
          parsed24hsDuration.length == 4
        ) {
          //fix times between 12 - 1 pm
          parsed24hsDuration = parsed24hsDuration.replace("24", "12");
        }

        if (parsed24hsDuration == 0) {
          parsed24hsDuration = "0000";
        }
        if (parsed24hsDuration.length == 3) {
          parsed24hsDuration = "0" + parsed24hsDuration;
        }

        let newTimeItem = {
          value: pmAmDuration.replace(" ", ""),
          stringValue: parsed24hsDuration,
          selected: false,
          disabled: false
        };

        let totalAppointmentDuration = calculateTotalAppointmentDuration(
          appointmentDuration,
          splitAppointmentFreeTime,
          splitAppointmentFinishTime,
          splitAppointmentBufferTime
        );
        totalAppointmentDuration = totalAppointmentDuration.split(":");
        let totalMinutes =
          parseInt(totalAppointmentDuration[0]) * 60 +
          parseInt(totalAppointmentDuration[1]);
        let updateTime = true;
        if (timeListForClashes.find(x => x.disabled) != null) {
          // check if there are any disabled times before processing

          let newTimeList = timeListForClashes.slice(0);
          newTimeList.push(newTimeItem);

          if (
            !canUserUseThisTimeDueToDoubleBookingDisabled(
              startDateAndTime,
              startTime,
              newTimeItem,
              totalMinutes,
              newTimeList,
              unavailableTimeList,
              this.props.dispatch
            )
          ) {
            updateTime = false;
          }
        }

        if (updateTime) {
          checkIfNewTimeWillCauseDoubleBooking(
            selectedDate,
            selectedTime,
            newTimeItem,
            totalMinutes,
            [newTimeItem, ...timeListForClashes],
            timeSlotsContainingAppointments,
            this.props.dispatch,
            doubleBookingEnabled,
            unavailableTimeList,
            multiServiceItem
          );
          if (
            !timeListForClashes.find(time => time.value == newTimeItem.value)
          ) {
            //only add time to list if it is a new time
            this.updateThisStep({
              timeListForClashes: [newTimeItem, ...timeListForClashes]
            });
          }
          setTimeout(() => {
            let dataToMerge = {
              startTime: newTimeItem,
              openClashTimeDropdown: false,
              temporarilySelectedTimeForClash: ""
            };
            updateClashData(dataToMerge, indexOfClash);
          }, 0); //execute in next cycle
        } else if (!updateTime) {
          let dataToMerge = {
            temporarilySelectedTimeForClash: ""
          };
          updateClashData(dataToMerge, indexOfClash);
        }
      };
      let handleBlur = ev => {
        parseAndFormatEnteredTime();
        this.updateThisStep(
          {
            openClashTimeDropdown: false
          },
          multiItemIndex
        );
      };
      let handleEnter = ev => {
        ev.target.blur();
      };

      let handleTyping = ev => {
        let finalValue = (/^\d+\:?\d*$/.exec(ev.target.value) || [])[0] || ""; // this regex will be empty when AM or PM is entered
        let rawValue = ev.target.value;
        let parsedAmPm = rawValue.replace(finalValue, "");
        parsedAmPm = parsedAmPm.toLowerCase();
        if (
          parsedAmPm &&
          (parsedAmPm.includes("p") ||
            parsedAmPm.includes("a") ||
            parsedAmPm.includes("pm") ||
            parsedAmPm.includes("am"))
        ) {
          if (!finalValue) {
            finalValue = (/^\d+\:[?\d*$]/.exec(ev.target.value) || [])[0] || ""; //this regex will strip off the PM / AM
            parsedAmPm = rawValue.replace(finalValue, "").toLowerCase();
          }
        } else {
          parsedAmPm = "";
        }

        finalValue += parsedAmPm;

        if ((finalValue || ev.target.value == "") && finalValue.length < 8) {
          let dataToMerge = {
            temporarilySelectedTimeForClash: finalValue
          };
          updateClashData(dataToMerge, indexOfClash);
        }
      };

      let handleFocus = () => {
        let dataToMerge = {
          openClashTimeDropdown: true
        };
        updateClashData(dataToMerge, indexOfClash);
      };

      let selectTime = time => {
        let totalAppointmentDuration = calculateTotalAppointmentDuration(
          appointmentDuration,
          splitAppointmentFreeTime,
          splitAppointmentFinishTime,
          splitAppointmentBufferTime
        );
        totalAppointmentDuration = totalAppointmentDuration.split(":");
        let totalMinutes =
          parseInt(totalAppointmentDuration[0]) * 60 +
          parseInt(totalAppointmentDuration[1]);

        checkIfNewTimeWillCauseDoubleBooking(
          selectedDate,
          selectedTime,
          time,
          totalMinutes,
          timeList,
          timeSlotsContainingAppointments,
          this.props.dispatch,
          doubleBookingEnabled,
          unavailableTimeList,
          multiServiceItem
        );
        let dataToMerge = {
          startTime: time,
          openClashTimeDropdown: false
        };
        updateClashData(dataToMerge, indexOfClash);
      };

      this.startTime = startTime;

      let that = this;
      let isDisabled =
        loadingTimesForCurrentResource ||
        disabled ||
        loadingBooking ||
        loadingClash ||
        selectedAppointmentStatus.id == 5;
      return (
        <ReactArrowHandler
          list={timeListForClashes}
          idProperty={"index"}
          textProperty={"value"}
          current={startTime}
        >
          <ValidMe
            validmevalue={() => {
              return !!that.startTime.value;
            }}
            defaulttext={Appointment.TimeDropdownPlaceholder}
            validmemessage={Errors.TimeRequired}
            validmefor="dropdown"
            group="firstStepAppointment"
          >
            <Txt
              open={openClashTimeDropdown}
              onFocus={handleFocus}
              searchQuery={temporarilySelectedTimeForClash}
              onBlur={handleBlur}
              onSearchChange={handleTyping}
              tabIndex={`${isDisabled ? "-1" : "0"}`}
              loading={loadingTimesForCurrentResource || loadingClash}
              fieldclasses={"field clash-time-dropdown"}
              disabled={isDisabled}
              type="dropdown"
              className={` clash-fixer dropdown selection  search ${
                startTime.value ? "value-selected" : ""
              }`}
              search
              placeholder={Appointment.TimeDropdownPlaceholder}
              text={startTime.value || Appointment.TimeDropdownPlaceholder}
            >
              <Dropdown.Menu>
                {timeListForClashes.sort(sortAmPmTime).map(time => {
                  return (
                    <Dropdown.Item
                      disabled={time.disabled}
                      selected={startTime.value == time.value}
                      className={`${
                        startTime.value == time.value ? "hovered" : ""
                      } ${time.disabled ? "disabled-insensitive" : ""} `}
                      key={`clash-time-dropdown${time.value}`}
                      onClick={selectTime.bind(this, time)}
                    >
                      {time.value}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Txt>
          </ValidMe>{" "}
        </ReactArrowHandler>
      );
    };

    let handleEcludeTimeFromRecurrence = (indexOfClash, clashItem) => {
      let {
        startDateAndTime,
        temporarilySelectedTimeForClash,
        startTime,
        openClashTimeDropdown,
        loadingClash
      } = clashItem;
      let {
        recurringOnTimeSelectedList
      } = this.props.advancedAppointmentStepData;

      if (selectedRepeatOption.id == "S") {
        //clicking X in this mode removes the specific recurrence from the recurrence section

        let recurringOnTimeItem = getRecurringOnTimeItem(
          startDateAndTime,
          startTime
        );
        let indexOfItemToDelete = recurringOnTimeSelectedList.findIndex(
          x => x == recurringOnTimeItem
        );
        if (indexOfItemToDelete > -1) {
          this.removeItemFromOnTimeList(indexOfItemToDelete); // remove clashed time from selected on times
          futureAppointmentClashes.splice(indexOfClash, 1);
          this.updateThisStep(
            {
              futureAppointmentClashes: futureAppointmentClashes
            },
            0
          ); //remove clash from clash list
        }
      } else {
        let dataToMerge = {
          excluded: true,
          processed: true,
          startDateAndTime:
            futureAppointmentClashes[indexOfClash].startDateAndTime, //reset these values in case of deletion ignoring all user input
          startTime: futureAppointmentClashes[indexOfClash].startTime //reset these values in case of deletion ignoring all user input
        };
        updateClashData(dataToMerge, indexOfClash);

        let futureClash =
          futureAppointmentClashesResolved[indexOfClash + 1] ||
          futureAppointmentClashes[indexOfClash + 1];
        if (futureClash) {
          this.getDatesAvailableForCurrentStaffOnSelectedDateForClashSection(
            futureClash.startDateAndTime,
            multiServiceList[0].selectedStaff.id,
            currentBookingId,
            indexOfClash + 1
          );
        }

        this.updateThisStep({
          currentClashBeingResolved: currentClashBeingResolved + 1
        });

        this.setState({
          goingBackInClashes: false
        });
      }
    };

    let handleAcceptAndProcessTimeForRecurrence = indexOfClash => {
      let doublebooking = this.props.appointmentStepData.doubleBookingEnabled;
      if (
        futureAppointmentClashesResolved[indexOfClash] &&
        futureAppointmentClashes[indexOfClash].startTime
      ) {
        doublebooking = false; //DES-792 if date/time changed for resolve, add to excluded array and not double booked array.
      }

      let dataToMerge = {
        excluded: false,
        processed: true,
        doublebooked: doublebooking //this.props.appointmentStepData.doubleBookingEnabled
      };
      updateClashData(dataToMerge, indexOfClash);

      let futureClash =
        futureAppointmentClashesResolved[indexOfClash + 1] ||
        futureAppointmentClashes[indexOfClash + 1];
      if (futureClash) {
        this.getDatesAvailableForCurrentStaffOnSelectedDateForClashSection(
          futureClash.startDateAndTime,
          multiServiceList[0].selectedStaff.id,
          currentBookingId,
          indexOfClash + 1
        );
      }

      this.setState({
        goingBackInClashes: false
      });

      this.updateThisStep({
        currentClashBeingResolved: currentClashBeingResolved + 1
      });
    };

    let goBackOneStepInTheProcessOfSolvingClashes = indexOfClash => {
      let dataToMerge = {
        processed: false
      };
      updateClashData(dataToMerge, indexOfClash);

      let previousClash =
        futureAppointmentClashesResolved[indexOfClash - 1] ||
        futureAppointmentClashes[indexOfClash - 1];
      if (previousClash) {
        this.getDatesAvailableForCurrentStaffOnSelectedDateForClashSection(
          previousClash.startDateAndTime,
          multiServiceList[0].selectedStaff.id,
          currentBookingId,
          indexOfClash - 1
        );
      }

      this.setState({
        goingBackInClashes: true
      });

      this.updateThisStep({
        currentClashBeingResolved: currentClashBeingResolved - 1
      });
    };

    let didUserFixTime = indexOfClash => {
      let currentlySelectedTimeForClash = (
        futureAppointmentClashesResolved[indexOfClash] ||
        futureAppointmentClashes[indexOfClash]
      ).startTime;

      return (
        (
          timeListForClashes.find(
            x => x.value == currentlySelectedTimeForClash.value
          ) || {}
        ).disabled == false
      );
    };

    let getResolvedClashesLabel = indexOfClash => {
      return (
        <div className="resolved-clashes-label">
          {AppointmentAdvanced.ResolvedClashes}
          <div
            onClick={goBackOneStepInTheProcessOfSolvingClashes.bind(
              this,
              indexOfClash
            )}
            className={`${
              currentClashBeingResolved == 1
                ? "disabled disabled-insensitive"
                : ""
            } refresh-icon`}
          ></div>
        </div>
      );
    };

    let disabledDueToSpecificRecurrenceMode = selectedRepeatOption.id == "S";

    return (
      <div className="recurring-clash-section span-like ">
        {currentClashBeingResolved > futureAppointmentClashes.length
          ? getResolvedClashesLabel(currentClashBeingResolved - 1)
          : futureAppointmentClashes.map((clash, i) => {
              return currentClashBeingResolved - 1 != i ? (
                ""
              ) : (
                <div
                  className={`${
                    this.state.goingBackInClashes
                      ? "slide-fast-from-right"
                      : "slide-fast-from-left"
                  }`}
                >
                  <div className="clash-box-section ">
                    <div className="clash-counter" key={`recurringlist${i}`}>
                      <div className="error-icon"></div>
                      <div className="counter-section">
                        {currentClashBeingResolved}&nbsp;/&nbsp;
                        {futureAppointmentClashes.length}
                      </div>
                    </div>
                    {getClashTimeDropdownSelector(
                      futureAppointmentClashesResolved[i] || clash,
                      i,
                      multiServiceList[0],
                      0,
                      disabledDueToSpecificRecurrenceMode
                    )}
                    {getClashDateDropdownSelector(
                      futureAppointmentClashesResolved[i] || clash,
                      i,
                      multiServiceList[0],
                      undefined,
                      disabledDueToSpecificRecurrenceMode
                    )}
                    {disabledDueToSpecificRecurrenceMode ? (
                      ""
                    ) : (
                      <i
                        onClick={handleAcceptAndProcessTimeForRecurrence.bind(
                          this,
                          i
                        )}
                        className={`${
                          !didUserFixTime(i) ? "disabled-insensitive" : ""
                        } checkmark`}
                      ></i>
                    )}
                    <i
                      onClick={handleEcludeTimeFromRecurrence.bind(
                        this,
                        i,
                        clash
                      )}
                      className="trash-icon"
                    ></i>
                  </div>
                  <div
                    onClick={goBackOneStepInTheProcessOfSolvingClashes.bind(
                      this,
                      i
                    )}
                    className={`${
                      currentClashBeingResolved == 1
                        ? "disabled disabled-insensitive"
                        : ""
                    } refresh-icon`}
                  ></div>
                </div>
              );
            })}
      </div>
    );
  };

  render() {
    let {
      offerId,
      recurringToggleOn,
      bookingCameFromDbWithOffer,
      futureAppointmentClashes
    } = this.props.advancedAppointmentStepData;
    let { paymentStatus, multiServiceList } = this.props.appointmentStepData;
    let {
      currentBookingId,
      bookingReference,
      sibblingBookingsTotalStartingFromZero,
      finishedLoadingSibblingBookings,
      isMultiServiceAppointment,
      checkoutAppointmentStepData: { invoiceKey },
      limitedPermissions
    } = this.props;
    let { StartTimeRequired } = window.APP.LANGUAGE.Errors;
    let {
      RecurringMultiserviceHoverMessage
    } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;
    let canDoRecurringAppointment = () => {
      return (
        paymentStatus != paymentStatusEnum.STATUS_PARTIAL &&
        paymentStatus != paymentStatusEnum.STATUS_PAID &&
        !isMultiServiceAppointment &&
        !invoiceKey &&
        (limitedPermissions.canEditAllBookings || !currentBookingId) &&
        !bookingCameFromDbWithOffer
      );
    };

    let that = this;

    let currentService = multiServiceList.find(
      x => x.bookingId == currentBookingId
    );
    let recurringClass = !isMultiServiceAppointment
      ? "recurring_section"
      : "recurring_section multi-service";
    let index = 0;
    return (
      <div className="ui form tabpane">
        <div className="top-section booking_ref_offers">
          <div
            className={`bookingRef_box ${bookingReference ? "" : " disabled"}`}
          >
            {window.APP.LANGUAGE.Pages.AppointmentAdvanced.ReferenceTitle}
            &nbsp; <span>{bookingReference}</span>
          </div>
          {this.getPurchagedOfferRedeemingInput()}
        </div>

        {getFinalListOfServicesWithAccessAndNoAccess(
          multiServiceList,
          sibblingBookingsTotalStartingFromZero
        ).map((multiServiceItem, multiItemIndex) => {
          let disabled = multiServiceItem.bookingId != currentBookingId;
          if (!multiServiceItem.noAccess) {
            if (
              !limitedPermissions.canEditAllBookings &&
              multiServiceItem.bookingId &&
              limitedPermissions.bookingsEditableByCurrentUser.indexOf(
                multiServiceItem.bookingId
              ) < 0
            ) {
              disabled = true;
            }
            index = multiServiceList.indexOf(multiServiceItem);
            return (
              <div
                key={`advanced-booking${multiItemIndex}`}
                className={`${disabled ? "disabled-row" : ""}`}
              >
                {this.getServiceRow(multiServiceItem, index, multiItemIndex)}
                {/* this.getServiceRow(multiServiceItem,multiItemIndex)} */}
              </div>
            );
          } else if (finishedLoadingSibblingBookings) {
            return this.getBookingRowsWithoutAccess();
          } else {
            return "";
          }
        })}
        <div className={`bottom-section ${recurringClass}`}>
          <hr />
          {isMultiServiceAppointment ? (
            <div className="recurring-left-section span-like">
              <h5
                className={`recur-title ${
                  !canDoRecurringAppointment() ? "disabled" : ""
                }`}
              >
                {window.APP.LANGUAGE.Pages.AppointmentAdvanced.RecurringTitle}
              </h5>
              <Checkbox
                disabled={!canDoRecurringAppointment()}
                toggle
                onChange={this.handleRecurringToggle}
                checked={recurringToggleOn}
                onMouseOver={this.handleRecurMouseIn}
                onMouseOut={this.handleRecurMouseOut}
              />
              {this.state.hover ? (
                <div className="booking_tooltip_text">
                  {RecurringMultiserviceHoverMessage}
                </div>
              ) : null}
            </div>
          ) : (
            <div className="recurring-left-section span-like">
              <h5 className="recur-title">
                {window.APP.LANGUAGE.Pages.AppointmentAdvanced.RecurringTitle}
              </h5>
              <Checkbox
                disabled={!canDoRecurringAppointment()}
                toggle
                onChange={this.handleRecurringToggle}
                checked={recurringToggleOn}
              />
            </div>
          )}

          {this.getClashRecurrenceSection()}
          {recurringToggleOn ? (
            <div
              className={`${
                canDoRecurringAppointment() ? "" : "disabled-row"
              } ${
                futureAppointmentClashes.length > 0 ? "clash-fix-recurring" : ""
              }`}
            >
              <div className="left-fields recurring_options">
                {this.getRecurringRepeatDropdown()}
                {this.getRecurringEveryDayDropdown()}
                {this.getRecurringEveryWeekDropdown()}
                {this.getRecurringEveryMonthDropdown()}
                {this.getRepeatOnWeekCheckboxList()}
                {this.getRecurringOnDatePicker()}
                {this.getRecurringOnTimeDropdown()}
                {this.getRepeatOnMonthCheckboxList()}
              </div>
              <div className="right-fields general_recurrence">
                {this.getRecurringEndOfPeriodRadioButtons()}
                {this.getRecurringEndDateDatePicker()}
                {this.getRecurringMultipleTimesDropdown()}
                {this.getBoxOfRecurringOnTimeList()}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    advancedAppointmentStepData:
      state.advancedAppointmentStepReducer.advancedAppointmentStepData,
    checkoutAppointmentStepData:
      state.appointmentCheckoutReducer.checkoutAppointmentStepData,
    loadingBooking: state.bookingReducer.loadingBooking,
    bookingChannel: state.bookingReducer.bookingChannel,
    savingBooking: state.bookingReducer.savingBooking,
    loadingAvailabilityDatesForSpecificRecurringSection:
      state.advancedAppointmentStepReducer
        .loadingAvailabilityDatesForSpecificRecurringSection,
    gotValidOffer: state.bookingReducer.gotValidOffer,
    isMultiServiceAppointment: state.bookingReducer.isMultiServiceAppointment,
    limitedPermissions: state.appointmentStepReducer.limitedPermissions,
    sibblingBookingsTotalStartingFromZero:
      state.bookingReducer.sibblingBookingsTotalStartingFromZero,
    currentBookingId: state.bookingReducer.currentBookingId,
    bookingReference: state.bookingReducer.bookingReference,
    doubleBookingEnabled: state.appointmentStepReducer.doubleBookingEnabled,
    loadingTimesForCurrentResource:
      state.appointmentStepReducer.loadingTimesForCurrentResource,
    loadedAvailabilitiesForSpecificRecurringAtLeastOnce:
      state.advancedAppointmentStepReducer
        .loadedAvailabilitiesForSpecificRecurringAtLeastOnce,
    loadingPurchasedOffer: state.bookingReducer.loadingPurchasedOffer,
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    finishedLoadingSibblingBookings:
      state.bookingReducer.finishedLoadingSibblingBookings,
    openRecurringOnDatePickerAppointment:
      state.advancedAppointmentStepReducer.openRecurringOnDatePickerAppointment,
    openEndDatePickerAppointment:
      state.advancedAppointmentStepReducer.openEndDatePickerAppointment
  };
}
